export default Object.freeze({
  tree: [],

  isLoading: true,
  selected: null,
});
